import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, ScrollRestoration, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import AllStays from "@/pages/AllStays";
import PropertyDetail from "@/pages/PropertyDetail";
import Experiences from "@/pages/Experiences";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import BecomeAHost from "@/pages/BecomeAHost";
import Admin from "@/pages/Admin";
import LegalPage from "@/pages/LegalPage";
import Gallery from "@/pages/Gallery";
import PartnerWithUs from "@/pages/PartnerWithUs";
import RetreatCategory from "@/pages/RetreatCategory";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/stays" element={<AllStays />} />
            <Route path="/stays/:slug" element={<PropertyDetail />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/partner" element={<PartnerWithUs />} />
            <Route path="/become-a-host" element={<BecomeAHost />} />
            <Route path="/retreats/:slug" element={<RetreatCategory />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/faq" element={<LegalPage slug="faq" />} />
            <Route path="/booking-policy" element={<LegalPage slug="booking-policy" />} />
            <Route path="/cancellation-policy" element={<LegalPage slug="cancellation-policy" />} />
            <Route path="/help" element={<LegalPage slug="help" />} />
            <Route path="/sustainability" element={<LegalPage slug="sustainability" />} />
            <Route path="/list-your-property" element={<LegalPage slug="list-your-property" />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
